import React from 'react'

import { graphql } from 'gatsby'
import styled from 'styled-components'

import Layout from '../../components/core/layout'
import SEO from '../../components/core/seo'
import ProgramSelector from '../../components/cross-template-statics/ProgramSelector'
import HeroInternal from '../../components/elements/HeroInternal'
import EarnYourDegree from '../../components/specific-to-template/campus/online/EarnYourDegree'
import OnlineCampusFAQs from '../../components/specific-to-template/campus/online/OnlineCampusFAQs'
import OnlineEducationBenefits from '../../components/specific-to-template/campus/online/OnlineEducationBenefits'
import TallLady from '../../components/specific-to-template/campus/online/TallLady'
import WhatToLookFor from '../../components/specific-to-template/campus/online/WhatToLookFor'
import { colors } from '../../style/design-system'

const OnlineCampus = ({ className, data }) => (
  <Layout>
    <SEO
      title="Online Healthcare Degree Programs | ABHES Accredited"
      useUMAAcronym
      description="Enroll today and earn your degree in an allied healthcare field online from Ultimate Medical Academy. Our accredited degree programs can be completed in 18 months."
      // Can the image below be a Gatsby image? That we we don't have to import it AND query for it.
      ogImage={data.heroImgLg.publicURL}
    />

    <div className={className}>
      <HeroInternal
        backgroundImage={{
          image: data.heroImgLg.childImageSharp.gatsbyImageData,
          objectPosition: '6vw top',
        }}
        backgroundImageMobile={{
          image: data.heroImgLg.childImageSharp.gatsbyImageData,
          objectPosition: 'center center',
        }}
        contentLg="Online Allied Healthcare Degree Programs"
      />
      <main>
        <div className="container">
          <h1 className="d-lg-none">Online Allied Healthcare Degree Programs</h1>
        </div>
        <EarnYourDegree />
        <TallLady />
        <div className="above-program-selector pt-8">
          <div className="container">
            <h2 className="h2 m-0">
              Explore our online programs offering degrees and diplomas in allied healthcare fields.
            </h2>
          </div>
        </div>
        <ProgramSelector showClearwater={false} />
        <OnlineEducationBenefits />
        <WhatToLookFor />
        <OnlineCampusFAQs />
      </main>
    </div>
  </Layout>
)

export default styled(OnlineCampus)`
  .above-program-selector {
    background-color: ${colors.dev.gray.h()};
  }
`

export const query = graphql`
  {
    heroImgLg: file(absolutePath: { regex: "/campus/online-campus-hero.jpg/" }) {
      childImageSharp {
        gatsbyImageData(quality: 85, width: 1266, placeholder: NONE, layout: FIXED)
      }
      publicURL
    }
  }
`
